import { ItemTypeConsts } from 'client/util/Constants';
import GettingStartedPanelSettings from 'client/components/GettingStartedPanel/GettingStartedPanelSettings';

const DirectoriesMainPanel = () => import('client/directories/DirectoriesMainPanel.vue');
const GSuiteAsidePanel = () => import('client/directories/GSuite/GSuiteAsidePanel.vue');
const O365AsidePanel = () => import('client/directories/Office365/O365AsidePanel.vue');

const { gSuite, office365 } = ItemTypeConsts;

const directoryProps = {
  gSuiteAsidePanel: {
    isExpanded: true,
    itemType: gSuite,
  },
  o365AsidePanel: {
    isExpanded: true,
    itemType: office365,
  },
  mainPanel: {
    isAsideOpen: false,
    itemType: ItemTypeConsts.cloudDirectory,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const metaData = {
  title: 'Cloud Directory Integrations',
  tooltipProps: {
    linkHref: GettingStartedPanelSettings[ItemTypeConsts.cloudDirectory].learnMoreUrl,
    pText: GettingStartedPanelSettings[ItemTypeConsts.cloudDirectory].tooltipText,
  },
};

export default [
  {
    path: '/directories/cloud-directories',
    name: 'cloudDirectory',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
    },
  },
  {
    path: '/directories/cloud-directories/g_suite/:id/activated',
    name: 'cloudDirectoryGsuiteActivated',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: GSuiteAsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.gSuiteAsidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/directories/cloud-directories/g_suite/:id/details',
    name: 'cloudDirectoryGsuiteDetails',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: GSuiteAsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.gSuiteAsidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/directories/cloud-directories/g_suite/error',
    name: 'cloudDirectoryGsuiteError',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: GSuiteAsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.gSuiteAsidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/directories/cloud-directories/g_suite/:id/reactivated',
    name: 'cloudDirectoryGsuiteReactivated',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: GSuiteAsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.gSuiteAsidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/directories/cloud-directories/g_suite/:id/import-users',
    name: 'cloudDirectoryGsuiteImport',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: GSuiteAsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.gSuiteAsidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/directories/cloud-directories/office_365/:id/activated',
    name: 'cloudDirectoryOffice365Activated',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: O365AsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.o365AsidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/directories/cloud-directories/office_365/:id/details',
    name: 'cloudDirectoryOffice365Details',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: O365AsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.o365AsidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/directories/cloud-directories/office_365/error',
    name: 'cloudDirectoryOffice365Error',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: O365AsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.o365AsidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/directories/cloud-directories/office_365/:id/reactivated',
    name: 'cloudDirectoryOffice365Reactivated',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: O365AsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.o365AsidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/directories/cloud-directories/office_365/:id/import-users',
    name: 'cloudDirectoryOffice365Import',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: O365AsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.o365AsidePanel,
        itemId: route.params.id,
      }),
    },
  },
];
